import { ApiService } from "../apiService";

export class DriversService extends ApiService {
    constructor() {
        super();
        
        this.path = '/Drivers';
    }

    getDrivers() {
        return this.get(this.path);
    }
    
    createDriver(newDriver) {
        return this.post(this.path, newDriver);
    }

    updateDriver(updatedDriver) {
        return this.put(this.path, updatedDriver);
    }

    deleteDriver(id) {
        return this.delete(this.path, id);
    }

    undoDriver(idDriver){
        return this.postUndo(this.path + "/undoDeleteDriver", idDriver);
    }
}